// src/api/endpoints.js
export const ENDPOINTS = {
  NOAUTH: {
    LOGIN: "/login",
    signin: "/register",

    //mobileotp

    createphonenumber: "send-otp-to-mobile",
    verifyotpforphone: "verify-otp-to-mobile",

    //forgotpassword
    otp: "/otp-for-forgot-password",
    verifyotp: "/verify-otp",
    rest: "/reset-password",

    //contactus
    createcontactus: "/contact-us",

    //firsttime oredr
    getfirsttimeorder: "/first-order-discount",
    checkpreview: "/checkout-preview",
  },

  AUTH: {
    //profile
    GET_MY_DETAILS: "/get-user-details",
    UPDATE_CANDIDATE_DETAILS: "/update-user-details",
    CHANGE_PASSWORD: "/change-password",

    //categories
    getcategories: "/active-categories",

    //product
    getproduct: () => "/all-products",
    getsingleproductss: (id) => `/product-details/${id}`,

    //address
    createaddres: "/create-address",
    getaddress: "/get-all-address",
    updateaddress: (id) => `/update-address/${id}`,
    deleteaddress: (id) => `/delete-address/${id}`,
    getsignleaddress: (id) => `/singe-address/${id}`,

    //cart
    withoutlogin: "/guest-cart-items",
    withlogin: "/cart-sync-items",
    afterlogin: "/get-cart-items",
    updatecart: (id) => `/cart-update-item/${id}`,
    deletecart: (id) => `/cart-delete-item/${id}`,
    addtocar: "/cart-add-item",
    checkpriview: "/checkout-preview",

    //blog
    getallblog: "/all-blogs",
    getsingleblog: (id) => `/single-blog/${id}`,

    //createorder
    createorder: "/create-payment-order",
    createCodOrder: "/create-cod-order",
    verifypayment: "/verify-payment",

    //hetorder
    getpurchaseorder: "/my-orders",
    getpayments: "/my-payments-history",
    getsignlepurchaseorder: (id) => `/my-order-details/${id}`,

    //dashboard
    dashboard: "/overview-dashboard",

    //review
    getreview: (id) => `/product-reviews/${id}`,
    createreview: "/add-review",

    //revieblog
    createblogreview: "add-blog-review",
  },
};
